import { render, staticRenderFns } from "./BModalUI.vue?vue&type=template&id=b0beb800&scoped=true"
import script from "./BModalUI.vue?vue&type=script&lang=js"
export * from "./BModalUI.vue?vue&type=script&lang=js"
import style0 from "./BModalUI.vue?vue&type=style&index=0&id=b0beb800&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0beb800",
  null
  
)

export default component.exports